import { useRouter } from 'next/router';
import { Button, Icon } from '@pairy/pds-react';

import { EmailCampaignTargetType } from '@/types/emailCampaign';

import ComponentToolTip from '../Tags/ComponentToolTip';

interface Props {
  targetType: EmailCampaignTargetType;
  targetId: number;
}

const EmailCampaignSendButton = ({ targetType, targetId }: Props) => {
  const router = useRouter();

  return (
    <ComponentToolTip
      description={
        <>
          이 콘텐츠를 내 이메일 주소로 고객에게 발송하고
          <br />
          전달, 오픈, 클릭 여부를 확인할 수 있습니다.
        </>
      }
    >
      <Button
        variant="skyblue_400"
        radius={8}
        paddingX={16}
        paddingY={12}
        textVariant="md-medium"
        width="100%"
        leftIcon={<Icon icon="ph:paper-plane-tilt" size={17} color="inherit" />}
        onClick={() =>
          router.push(
            `/user/campaign/create?targetType=${targetType}&targetId=${targetId}`,
          )
        }
      >
        이메일로 발송하기
      </Button>
    </ComponentToolTip>
  );
};

export default EmailCampaignSendButton;
